// API client setup — wires @dvvb/sdk to VITE_API_BASE + bearer token from localStorage.

import { configureClient } from '@dvvb/sdk/client';

export const TOKEN_STORAGE_KEY = 'dvvb.auth.token';

export const API_BASE: string =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  'https://api.dvvb.io';

export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setStoredToken(token: string | null) {
  try {
    if (token == null) localStorage.removeItem(TOKEN_STORAGE_KEY);
    else localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } catch {
    /* noop — private browsing */
  }
}

let initialised = false;
export function initApiClient() {
  if (initialised) return;
  initialised = true;
  configureClient({
    baseUrl: API_BASE,
    getToken: getStoredToken,
  });
}
